// extracted by mini-css-extract-plugin
module.exports = {"type":"Type_type__1Nhlt","green":"Type_green__1_LGY","red":"Type_red__2ubTg"};